import Snackbar from "node-snackbar";

export default {

    getPosition: function () {
        if (document.documentElement.clientWidth > 768) {
            return "bottom-left";
        } else {
            return "bottom-center";
        }
    },

    success: function (message, position) {
        position = this.getPosition();
        Snackbar.show({customClass: "themed-snackbar", textColor: "#fff", pos: position, text: message, showAction: false});
    },

    error: function (message, position) {
        position = this.getPosition();
        Snackbar.show({customClass: "themed-snackbar z-50 bg-red-600",pos: position, text: message, actionTextColor: "rgba(254, 202, 202)", duration: 8000});
    },

    info: function (message, position) {
        position = this.getPosition();
        Snackbar.show({customClass: "themed-snackbar", textColor: "#fff", pos: position, text: message, showAction: false});
    },

    warning: function (message, position) {
        position = this.getPosition();
        Snackbar.show({customClass: "themed-snackbar z-50 bg-yellow-600", pos: position, text: message, actionTextColor: "rgba(254, 243, 199)", duration: 8000});
    },

    make: function (options) {
        Snackbar.show(options);
    },
};
